import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-brand-50 py-16 sm:py-24" aria-labelledby="bonuses-title" data-id="element-68" data-mp="av35ut3p3515">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-69" data-mp="at8uo6i86ra9">
        <div className="text-center" data-id="element-70" data-mp="fsv9ulhm6hlp">
          <span className="inline-flex items-center gap-2 rounded-full bg-alert px-4 py-1.5 text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-71" data-mp="frtljfbl7ym1">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-72" data-mp="5x1m05yg31om" />
            5 Exclusive Bonuses
          </span>
          <h2 id="bonuses-title" className="mt-4 font-serif text-[32px] font-extrabold leading-tight text-ink sm:text-5xl" data-id="element-73" data-mp="3o2wqzdp1jxl4">
            Today, you’ll also receive these <em className="text-brand-600" data-id="element-74" data-mp="1mai4e1bjy4yd">5 bonuses free</em>
          </h2>
          <p className="mt-4 text-lg font-semibold text-muted" data-id="element-75" data-mp="1m8feriebadu6">
            Total bonus value: <span className="font-extrabold text-ink line-through decoration-alert" data-id="element-76" data-mp="1r8jtp3zkn0ia">$147</span>
          </p>
        </div>

        <div className="mt-12 space-y-16 sm:space-y-20" data-id="element-77" data-mp="3dfd2hjen40sv">
          {bonuses.map((b, i) => <article key={b.number} className="grid items-center gap-6 md:grid-cols-2 md:gap-12" data-id="element-78" data-mp="3ddipcr9m1czc" data-mpi={i}>
              <div className={`-mx-4 sm:mx-0 ${i % 2 === 1 ? 'md:order-2' : ''}`} data-id="element-79" data-mp="3r8ktp9yt6ua1">
                <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="w-full" loading="lazy" data-id="element-80" data-mp="3n79cnsu03hdg" />
              </div>
              <div data-id="element-81" data-mp="2ugqzfyzkbzmb">
                <div className="flex flex-wrap items-center gap-2" data-id="element-82" data-mp="2uh96zrroe09j">
                  <span className="rounded-md bg-brand-700 px-2.5 py-1 text-xs font-extrabold uppercase tracking-widest text-white" data-id="element-83" data-mp="38g8vmzf6uf5p">
                    Bonus #{b.number}
                  </span>
                  <span className="text-sm font-bold text-muted" data-id="element-84" data-mp="nq1asy20t0rw">
                    Value: <span className="line-through decoration-alert" data-id="element-85" data-mp="no6r1n2hjepe">${b.value}</span>
                  </span>
                  <span className="rounded-md bg-cta px-2.5 py-1 text-xs font-extrabold uppercase tracking-widest text-white" data-id="element-86" data-mp="it13ykxcjtzq">
                    Free today
                  </span>
                </div>
                <h3 className="mt-3 font-serif text-[28px] font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-87" data-mp="3hju8l027a9jl">{b.title}</h3>
                <p className="mt-3 text-[17px] leading-relaxed text-muted" data-id="element-88" data-mp="3qifm2gsteydi">{b.text}</p>
                {b.items.length > 0 && <ul className="mt-4 space-y-2" data-id="element-89" data-mp="2ttgd0zkepsk9">
                    {b.items.map(item => <li key={item} className="flex gap-2.5 text-[16px] leading-snug text-ink" data-id="element-90" data-mp="2xv1xb5z9t94h">
                        <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-91" data-mp="32s23dgw4ebvl" />
                        {item}
                      </li>)}
                  </ul>}
                {b.closing && <p className="mt-4 text-[16px] font-semibold leading-relaxed text-brand-800" data-id="element-92" data-mp="2a2ldoqzvx932">{b.closing}</p>}
              </div>
            </article>)}
        </div>

        <CtaButton className="mt-16" label="I want all 5 bonuses free" data-id="element-93" data-mp="27j8b14rgnfx9" />
      </div>
    </section>;
}